
import './ShootingStars.css';

const Stars = () => {
  return (
    <div className="star-container" >
      <div className="stars"></div>
      <div className="shooting-star"></div>
      <div className="shooting-star"></div>
      <div className="shooting-star"></div>
      <div className="shooting-star"></div>
      <div className="shooting-star"></div>
    </div>
    
  );
};

export default Stars;